import { apiCaller } from '../ApiCaller/ApiCaller';

export async function fetchAllDataOfContact(data = "") {

   const fetchAllDetailsData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/fetchAllDetails");

      return fetchAllDetailsData;
}